export default "<h3>Code Generation Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"